import { render, staticRenderFns } from "./SpreadSheet.vue?vue&type=template&id=bb97d8ee&"
import script from "./SpreadSheet.vue?vue&type=script&lang=js&"
export * from "./SpreadSheet.vue?vue&type=script&lang=js&"
import style0 from "./SpreadSheet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports